<template>
  <v-dialog 
    :model-value="dialog" 
    max-width="500px" 
    persistent>
    <template v-slot:activator="{  }" >
      <v-btn color="#1976d2" variant="flat" dark class="mb-2" @click="close" v-show="isEditable">{{$t('i18n_new')}}</v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">{{$t('i18n_conf_edit_skill')}}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form
            ref="skillForm"
            v-model="formValid">
            <v-row>
              <v-col cols="12" sm="12">
                <v-text-field 
                  :label="$t('i18n_conf_skill')"
                  v-model="toEdit.name"
                  :rules="formRules"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-select
                  :items="relevanz"
                  v-model="toEdit.relevance"
                  :label="$t('i18n_conf_relevance')"
                  :rules="formRules"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-select
                  :items="ratings"
                  item-title="skaleName"
                  return-object
                  :model-value="toEdit.rating"
                  @update:model-value="updateRating"
                  :label="$t('i18n_conf_rating')"
                  :rules="formRules"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12">
                <v-autocomplete
                  :items="classifications.filter(classification => classification.leaf)"
                  item-title="name"
                  :filter="customFilter"
                  v-model="toEdit.classification"
                  clearable
                  return-object
                  :label="$t('i18n_conf_category')"
                  :rules="formRules">
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12">
                <v-textarea
                        auto-grow
                        :label="$t('i18n_conf_description')"
                        v-model="toEdit.description"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error"  @click="close">{{$t('i18n_cancel')}}</v-btn>
        <v-btn color="primary" @click="save">{{$t('i18n_save')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState } from "vuex";
  import { constructClassificationHierarchy } from "../../utils/configurationPage.utils";

  export default {
    data: () => ({
      formValid:true,
      formRules: [
                v => !!v || "Field is required"
            ]
    }),
    props: {
      toEdit: Object,
      dialog: Boolean
    },
    computed: {
      ...mapState({
        classifications: state => state.configuration.classifications,
        ratings: state => state.configuration.rating,
        relevanz: state => state.general.relevanz,
        isEditable: state => state.general.selectedPageEditable
      }),
    },
    methods: {
      updateRating(newRating) {
        this.toEdit.rating = newRating;
      },
      close() {
        this.$emit("fire-close", !this.dialog);
      },
      save() {
        this.$refs.skillForm.validate();
        if(this.formValid) {
          this.$emit("fire-save", this.toEdit);
        }
      },
      customFilter (item, queryText) {
        const textOne = item.name.toLowerCase();
        const searchText = queryText.toLowerCase();

        return textOne.indexOf(searchText) > -1;
      },
      constructClassificationHierarchy
    }
  }
</script>
